import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { Zone, ZoneColorWeight, ZoneMetadata } from "@common/ADAPT.Common.Model/methodology/zone";
import { Breakpoint } from "@common/ux/responsive/breakpoint";
import { ResponsiveService } from "@common/ux/responsive/responsive.service";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

const zoneClass: { [zone in Zone]: string } = {
    [Zone.OrganisationDesign]: "organisation-design",
    [Zone.EconomicEngine]: "economic-engine",
    [Zone.HealthyCulture]: "healthy-culture",
    [Zone.FinanceAndOwnership]: "finance-and-ownership",
    [Zone.ResearchAndDevelopment]: "research-development",
};

@Component({
    selector: "adapt-render-zone-map",
    templateUrl: "./render-zone-map.component.html",
    styleUrl: "./render-zone-map.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class RenderZoneMapComponent {
    public readonly Zone = Zone;
    public readonly ZoneColorWeight = ZoneColorWeight;
    public readonly ZoneMetadata = ZoneMetadata;

    @Input() public set verticalLayout(value: boolean) {
        this.verticalLayout$.next(value);
    }

    @Input() public zoneContentTemplate?: TemplateRef<unknown>;
    @Input() public fullLayoutBreakpoint?: Breakpoint;
    @Input() public zoneMenuTemplate?: TemplateRef<unknown>;

    @Input() public zoneContentContainerTemplate?: TemplateRef<unknown>;

    @Input() public showGlobalZoneLocation = false;
    @Input() public globalZoneLocationLabel = "";
    @Input() public globalZoneContentContainerTemplate?: TemplateRef<unknown>;

    public isFullLayout$: Observable<boolean>;
    private verticalLayout$ = new BehaviorSubject<boolean>(false);

    public constructor(
        responsiveService: ResponsiveService,
    ) {
        this.isFullLayout$ = combineLatest([responsiveService.currentBreakpoint$, this.verticalLayout$]).pipe(
            map(([breakpoint, verticalLayoutRequested]) => {
                return (!verticalLayoutRequested && this.fullLayoutBreakpoint)
                    ? breakpoint.is(this.fullLayoutBreakpoint)
                    : breakpoint.isDesktopSize;
            }),
        );
    }
    public getZoneClass(zone: Zone) {
        return ZoneMetadata.BackgroundStyleClass[zone];
    }

    public zoneContentClass(zone: Zone) {
        return zoneClass[zone];
    }
}
